import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

const defaultTZ = 'America/New_York';

export function dateHelper() {
  const monthArray = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  function formatDateForDatePicker(dateString) {
    const d = new Date(dateString);
    const [month, date, year] = d.toDateString().split(' ').slice(1);
    return `${month} ${date}, ${year}`;
  }

  /**
   *
   * @param {String} dateString
   * @returns Jan 01, 2025
   */
  function formatToMDY(dateString) {
    if (!dateString) return;
    const date = dateString.split('T'); // ignore time stamp
    return dayjs(date[0]).format('MMM D, YYYY');
  }

  /**
   *
   * @param {String} dateString
   * @returns Jan 01
   */
  function formatToMonthDay(dateString) {
    if (!dateString) return;
    const date = dateString.split('T'); // ignore time stamp
    return dayjs(date[0]).format('MMM DD');
  }

  /**
   * Create a standardized timezone
   * return ISO formatted string
   * @param {String} dateString
   * @returns `2025-01-01`
   */
  function formatToISO(dateString) {
    return dayjs(dateString, defaultTZ).format('YYYY-MM-DD');
  }

  function getTime(input) {
    const hrsMinsSec = input
      .toLocaleString('en-US', {
        timeZone: defaultTZ,
      })
      .split(', ')[1];
    const meridian = hrsMinsSec.split(' ')[1];
    const [h, m] = hrsMinsSec.split(' ')[0].split(':');

    return `${h}:${m} ${meridian}`;
  }

  function formatDateForStagedExpiry(input) {
    const postedTime = new Date(input);
    const newTime = new Date(postedTime.getTime() + 60000 * 10);
    const [month, date, year] = newTime.toDateString().split(' ').slice(1); // Mon Dec 05 2022'

    const day = `${month} ${date}, ${year}`; // Jan 6, 2022
    const time = getTime(newTime); // 1:53 PM
    const timezone = '(US/Eastern)';

    return `${day} ${time} ${timezone}`; // `Jan 6, 2022 1:53 PM (US/Eastern)`;
  }

  function formateDate(input, includeYear = true) {
    const postedTime = new Date(input);
    const month = monthArray[postedTime.getUTCMonth()];
    const date = postedTime.getUTCDate();
    const year = postedTime.getUTCFullYear();

    return `${month} ${date}` + (includeYear ? `, ${year}` : ''); // Jan 6, 2022 or Jan 6
  }

  function dateDiff(date) {
    const fromDate = new Date(date);
    const now = new Date();
    const diff = now.getTime() - fromDate.getTime();

    return diff / (1000 * 60 * 60 * 24);
  }

  function isWithin24Hours(date) {
    const dayDiff = dateDiff(date);

    return dayDiff <= 1;
  }

  function isWithin48Hours(date) {
    const dayDiff = dateDiff(date);
    return dayDiff <= 2;
  }

  function formatDateForCSVExport() {
    return new Date().toLocaleDateString('en-us', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }

  function getTodayInEST() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
  }

  /**
   * Returns a date string with a UTC timestamp that is translates to EST
   * We're hardcoding the value here because the timestamp is not important
   * This is only required for endpoint that expect a date timestamp
   * @param {String} dateString
   * @returns YYYY-MM-DDT06:00:00.000Z
   */
  function formatToUTC(dateString) {
    if (!dateString) return;
    const ds = dateString.split('T');
    const isoDate = formatToISO(ds[0]);
    return `${isoDate}T06:00:00.000Z`;
  }

  return {
    formatDateForDatePicker,
    formatDateForStagedExpiry,
    formateDate,
    formatDateForCSVExport,
    isWithin24Hours,
    isWithin48Hours,
    dateDiff,
    formatToMDY,
    formatToMonthDay,
    formatToISO,
    getTodayInEST,
    formatToUTC,
  };
}
